var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "tabBar" },
      _vm._l(_vm.tabBars, function (i, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "tabItem",
            class: { itemActive: _vm.curIndex == index },
            on: {
              click: function ($event) {
                return _vm.changeTab(i, index)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(i) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.curIndex == 0
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form0",
                attrs: {
                  model: _vm.form0,
                  "label-width": "170px",
                  rules: _vm.rules0,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程名称：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: "请输入课程名称",
                          },
                          model: {
                            value: _vm.form0.courseName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "courseName", $$v)
                            },
                            expression: "form0.courseName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程负责人：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: "请输入课程负责人",
                          },
                          model: {
                            value: _vm.form0.courseLeader,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "courseLeader", $$v)
                            },
                            expression: "form0.courseLeader",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        key: "contactNumber",
                        attrs: { label: "联系电话：", prop: "contactNumber" },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入联系电话" },
                          model: {
                            value: _vm.form0.contactNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "contactNumber", $$v)
                            },
                            expression: "form0.contactNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "主要开课平台：" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入主要开课平台" },
                          model: {
                            value: _vm.form0.mainClassPlatform,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "mainClassPlatform", $$v)
                            },
                            expression: "form0.mainClassPlatform",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "申报学校：" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入申报学校" },
                          model: {
                            value: _vm.form0.courseSchool,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "courseSchool", $$v)
                            },
                            expression: "form0.courseSchool",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属专业大类：", prop: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: { change: _vm.chooseMajor },
                            model: {
                              value: _vm.form0.majorCatId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "majorCatId", $$v)
                              },
                              expression: "form0.majorCatId",
                            },
                          },
                          _vm._l(_vm.majorList, function (i) {
                            return _c("el-option", {
                              key: i.id,
                              attrs: { label: i.majorName, value: i.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属专业二级类：", prop: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: { change: _vm.chooseMajorTwo },
                            model: {
                              value: _vm.form0.majorGroupId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "majorGroupId", $$v)
                              },
                              expression: "form0.majorGroupId",
                            },
                          },
                          _vm._l(_vm.majorListTwo, function (i) {
                            return _c("el-option", {
                              key: i.id,
                              attrs: { label: i.majorName, value: i.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "专业类代码：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: "请输入专业类代码",
                          },
                          model: {
                            value: _vm.form0.professionalCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "professionalCode", $$v)
                            },
                            expression: "form0.professionalCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "填表日期：" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "选择填表日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.form0.declarationDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "declarationDate", $$v)
                            },
                            expression: "form0.declarationDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit("form0")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.curIndex == 1
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form1",
                attrs: {
                  model: _vm.form1,
                  "label-width": "170px",
                  rules: _vm.rules1,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程名称：", prop: "courseName" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: "请输入课程名称",
                          },
                          model: {
                            value: _vm.form1.courseName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "courseName", $$v)
                            },
                            expression: "form1.courseName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "课程立项项目序号：",
                          prop: "courseProjectNo",
                        },
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.chooseLixiang,
                                  callback: function ($$v) {
                                    _vm.chooseLixiang = $$v
                                  },
                                  expression: "chooseLixiang",
                                },
                              },
                              _vm._l(_vm.lixiang, function (i) {
                                return _c("el-option", {
                                  key: i,
                                  attrs: { label: i, value: i },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 19 } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "手填序号",
                                maxlength: "4",
                                oninput:
                                  "this.value=this.value.match(/^[1-9][0-9]*$/);",
                              },
                              model: {
                                value: _vm.form1.courseProjectNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form1, "courseProjectNo", $$v)
                                },
                                expression: "form1.courseProjectNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "课程负责人：", prop: "courseLeader" },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: "请输入课程负责人",
                          },
                          model: {
                            value: _vm.form1.courseLeader,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "courseLeader", $$v)
                            },
                            expression: "form1.courseLeader",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "负责人所在单位：", prop: "unit" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入负责人所在单位",
                            maxlength: "30",
                          },
                          model: {
                            value: _vm.form1.unit,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "unit", $$v)
                            },
                            expression: "form1.unit",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程对象：" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.form1.courseObject,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "courseObject", $$v)
                              },
                              expression: "form1.courseObject",
                            },
                          },
                          [
                            _c("el-checkbox", { attrs: { label: "本科生课" } }),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "专科生课" } }),
                            _vm._v(" "),
                            _c("el-checkbox", {
                              attrs: { label: "社会学习者课" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程性质：" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.form1.courseNature,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "courseNature", $$v)
                              },
                              expression: "form1.courseNature",
                            },
                          },
                          [
                            _c("el-checkbox", {
                              attrs: { label: "高校学分认定课" },
                            }),
                            _vm._v(" "),
                            _c("el-checkbox", {
                              attrs: { label: "社会学习者课程" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticClass: "type", attrs: { label: "课程类型：" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            on: { change: _vm.changeCourseType },
                            model: {
                              value: _vm.form1.courseType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "courseType", $$v)
                              },
                              expression: "form1.courseType",
                            },
                          },
                          [
                            _c("el-checkbox", {
                              attrs: { label: "专业基础课" },
                            }),
                            _vm._v(" "),
                            _c("el-checkbox", {
                              attrs: { label: "专业核心课" },
                            }),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "实践课程" } }),
                            _vm._v(" "),
                            _c("el-checkbox", {
                              attrs: { label: "公共基础课" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "courseType" },
                          [
                            _c("span", [_vm._v("(")]),
                            _vm._v(" "),
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.courseTypeGgjc,
                                  callback: function ($$v) {
                                    _vm.courseTypeGgjc = $$v
                                  },
                                  expression: "courseTypeGgjc",
                                },
                              },
                              [
                                _c("el-checkbox", {
                                  attrs: { label: "大学生文化素质教育课" },
                                }),
                                _vm._v(" "),
                                _c("el-checkbox", {
                                  attrs: { label: "创新创业类课" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(")")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程讲授语言：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.changeLanguage },
                            model: {
                              value: _vm.form1.courseTeachingLanguage,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form1,
                                  "courseTeachingLanguage",
                                  $$v
                                )
                              },
                              expression: "form1.courseTeachingLanguage",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "中文" } }, [
                              _vm._v("中文"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              { attrs: { label: "中文+外文字幕" } },
                              [_vm._v("中文+外文字幕")]
                            ),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "外文" } }, [
                              _vm._v("外文"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isForLan
                          ? _c(
                              "div",
                              { staticClass: "language" },
                              [
                                _c("span", [_vm._v("外文语种")]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: { placeholder: "请输入外文语种" },
                                  model: {
                                    value: _vm.foreignLanguage,
                                    callback: function ($$v) {
                                      _vm.foreignLanguage = $$v
                                    },
                                    expression: "foreignLanguage",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "开放程度：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form1.degreeOpenness,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "degreeOpenness", $$v)
                              },
                              expression: "form1.degreeOpenness",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: "完全开放：自由注册，免费学习",
                                },
                              },
                              [_vm._v("完全开放：自由注册，免费学习")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label:
                                    "有限开放：仅对学校（机构）组织的学习者开放或付费学习",
                                },
                              },
                              [
                                _vm._v(
                                  "有限开放：仅对学校（机构）组织的学习者开放或付费学习"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "主要开课平台：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入主要开课平台",
                            maxlength: "30",
                          },
                          model: {
                            value: _vm.form1.mainClassPlatform,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "mainClassPlatform", $$v)
                            },
                            expression: "form1.mainClassPlatform",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "平台首页网址：", prop: "website" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder:
                              "请输入平台首页网址(网址应以http://或https://开头,示例http://www.xxx.com)",
                          },
                          model: {
                            value: _vm.form1.website,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "website", $$v)
                            },
                            expression: "form1.website",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "首期上线平台及时间：" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "40%" },
                          attrs: { placeholder: "请输入首期上线平台" },
                          model: {
                            value: _vm.form1.onlinePlatformTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "onlinePlatformTime", $$v)
                            },
                            expression: "form1.onlinePlatformTime",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "59%" },
                          attrs: {
                            type: "date",
                            placeholder: "选择上线日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.form1.onlinePlatformDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "onlinePlatformDate", $$v)
                            },
                            expression: "form1.onlinePlatformDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程开设期次：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入课程开设期次",
                            oninput:
                              "this.value=this.value.match(/^[0-9]*[1-9][0-9]*$/,'');",
                          },
                          model: {
                            value: _vm.form1.courseDuration,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "courseDuration", $$v)
                            },
                            expression: "form1.courseDuration",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程链接：", prop: "courseLink" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder:
                              "请输入课程链接(网址应以http://或https://开头,示例http://www.xxx.com)",
                          },
                          model: {
                            value: _vm.form1.courseLink,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "courseLink", $$v)
                            },
                            expression: "form1.courseLink",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "team" }, [
                      _vm._v(
                        "\n          若因同一门课程课时较长，分段在线开设，请填写下表(非必填)：\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "majorWarp" },
                      [
                        _vm._l(_vm.form1.courseHourListParams, function (i, j) {
                          return [
                            _c(
                              "el-row",
                              { key: j },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 20 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "courseItem",
                                        attrs: { label: "分段在线开设：" },
                                      },
                                      [
                                        _c("el-col", { attrs: { span: 2 } }, [
                                          _c("div", { staticClass: "xuhao" }, [
                                            _vm._v("序号：" + _vm._s(j + 1)),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "课程名称",
                                                maxlength: "30",
                                              },
                                              model: {
                                                value: i.courseName,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "courseName", $$v)
                                                },
                                                expression: "i.courseName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "负责人",
                                                maxlength: "30",
                                              },
                                              model: {
                                                value: i.responsiblePerson,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    i,
                                                    "responsiblePerson",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "i.responsiblePerson",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "负责人单位",
                                                maxlength: "30",
                                              },
                                              model: {
                                                value: i.responsibleUnit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    i,
                                                    "responsibleUnit",
                                                    $$v
                                                  )
                                                },
                                                expression: "i.responsibleUnit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "课时(周)",
                                                oninput:
                                                  "this.value=(this.value.match(/\\d+(.\\d{0,2})?/)||[''])[0]",
                                              },
                                              model: {
                                                value: i.classHours,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "classHours", $$v)
                                                },
                                                expression: "i.classHours",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 6 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                key: "'courseHourListParams.' + j + '.courseLink'",
                                                attrs: {
                                                  prop:
                                                    "courseHourListParams." +
                                                    j +
                                                    ".courseLink",
                                                  rules: {
                                                    type: "url",
                                                    message:
                                                      "请输入正确的网址格式",
                                                    trigger: ["blur", "change"],
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "课程链接",
                                                  },
                                                  model: {
                                                    value: i.courseLink,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "courseLink",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "i.courseLink",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "btnsGroup",
                                    attrs: { span: 4 },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: { click: _vm.addWorks },
                                      },
                                      [_vm._v("新增")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeWorks(j)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit1("form1")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.curIndex == 2
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form2",
                attrs: {
                  model: _vm.form2,
                  "label-width": "170px",
                  rules: _vm.rules2,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c("div", { staticClass: "team" }, [
                      _vm._v("课程团队主要成员（含负责人，限5人之内）:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "majorWarp" },
                      [
                        _vm._l(_vm.form2.courseTeamListParams, function (i, j) {
                          return [
                            _c(
                              "el-row",
                              { key: j },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 20 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "courseItem",
                                        attrs: { label: "主要成员基本信息：" },
                                      },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "姓名" },
                                              model: {
                                                value: i.name,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "name", $$v)
                                                },
                                                expression: "i.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "单位" },
                                              model: {
                                                value: i.unit,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "unit", $$v)
                                                },
                                                expression: "i.unit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "职称" },
                                              model: {
                                                value: i.jobTitle,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "jobTitle", $$v)
                                                },
                                                expression: "i.jobTitle",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                key: "'courseTeamListParams.' + j + '.mobile'",
                                                attrs: {
                                                  prop:
                                                    "courseTeamListParams." +
                                                    j +
                                                    ".mobile",
                                                  rules: _vm.rules2.mobile,
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    oninput:
                                                      "this.value=this.value.replace(/\\D/g,'')",
                                                    maxlength: "11",
                                                    placeholder: "手机号码",
                                                  },
                                                  model: {
                                                    value: i.mobile,
                                                    callback: function ($$v) {
                                                      _vm.$set(i, "mobile", $$v)
                                                    },
                                                    expression: "i.mobile",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 4 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                key: "'courseTeamListParams.' + j + '.email'",
                                                attrs: {
                                                  prop:
                                                    "courseTeamListParams." +
                                                    j +
                                                    ".email",
                                                  rules: _vm.rules2.email,
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "电子邮箱",
                                                  },
                                                  model: {
                                                    value: i.email,
                                                    callback: function ($$v) {
                                                      _vm.$set(i, "email", $$v)
                                                    },
                                                    expression: "i.email",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "平台用户名",
                                              },
                                              model: {
                                                value: i.platformUserName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    i,
                                                    "platformUserName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "i.platformUserName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "承担任务：" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入在本课程中承担的工作",
                                          },
                                          model: {
                                            value: i.undertakeTasks,
                                            callback: function ($$v) {
                                              _vm.$set(i, "undertakeTasks", $$v)
                                            },
                                            expression: "i.undertakeTasks",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "btnsGroup",
                                    attrs: { span: 4 },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: { click: _vm.addTeam },
                                      },
                                      [_vm._v("新增")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeTeam(j)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "team" }, [
                      _vm._v("课程团队其他成员（非必填）:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "majorWarp" },
                      [
                        _vm._l(
                          _vm.form2.courseTeamOtherListParams,
                          function (i, j) {
                            return [
                              _c(
                                "el-row",
                                { key: j },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 20 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "courseItem",
                                          attrs: {
                                            label: "其他成员基本信息：",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 4 } },
                                            [
                                              _c("el-input", {
                                                attrs: { placeholder: "姓名" },
                                                model: {
                                                  value: i.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(i, "name", $$v)
                                                  },
                                                  expression: "i.name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 5 } },
                                            [
                                              _c("el-input", {
                                                attrs: { placeholder: "单位" },
                                                model: {
                                                  value: i.unit,
                                                  callback: function ($$v) {
                                                    _vm.$set(i, "unit", $$v)
                                                  },
                                                  expression: "i.unit",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 4 } },
                                            [
                                              _c("el-input", {
                                                attrs: { placeholder: "职称" },
                                                model: {
                                                  value: i.jobTitle,
                                                  callback: function ($$v) {
                                                    _vm.$set(i, "jobTitle", $$v)
                                                  },
                                                  expression: "i.jobTitle",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 5 } },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: "平台用户名",
                                                },
                                                model: {
                                                  value: i.platformUserName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      i,
                                                      "platformUserName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "i.platformUserName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "承担任务：" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder:
                                                "请输入在本课程中承担的工作",
                                            },
                                            model: {
                                              value: i.undertakeTasks,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  i,
                                                  "undertakeTasks",
                                                  $$v
                                                )
                                              },
                                              expression: "i.undertakeTasks",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "btnsGroup",
                                      attrs: { span: 4 },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                          },
                                          on: { click: _vm.addTeamOther },
                                        },
                                        [_vm._v("新增")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeTeamOther(j)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程负责人教学情况：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 8,
                            maxlength: "600",
                            "show-word-limit": "",
                            placeholder:
                              "请输入近5年来在承担学校教学任务、开展教学研究、获得教学奖励方面的情况。(不超过500字)",
                          },
                          model: {
                            value: _vm.form2.teachingSituation,
                            callback: function ($$v) {
                              _vm.$set(_vm.form2, "teachingSituation", $$v)
                            },
                            expression: "form2.teachingSituation",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit2("form2")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.curIndex == 3
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form3",
                attrs: {
                  model: _vm.form3,
                  "label-width": "170px",
                  rules: _vm.rules3,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程简介及课程特色：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 18,
                            maxlength: "900",
                            "show-word-limit": "",
                            placeholder:
                              "请输入课程主要内容及面向对象，本课程运用信息技术在课程体系、教学内容和教学方法等方面的改革情况。(不超过800字)",
                          },
                          model: {
                            value: _vm.form3.courseIntroduction,
                            callback: function ($$v) {
                              _vm.$set(_vm.form3, "courseIntroduction", $$v)
                            },
                            expression: "form3.courseIntroduction",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit3("form3")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.curIndex == 4
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form4",
                attrs: {
                  model: _vm.form4,
                  "label-width": "170px",
                  rules: _vm.rules4,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程考核（试）情况：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 18,
                            maxlength: "600",
                            "show-word-limit": "",
                            placeholder:
                              "[对学习者学习的考核（试）办法，成绩评定方式等。如果为学分认定课，须将课程数据信息表中相应的两期在线试题附后](不超过500字,附件材料非必填)",
                          },
                          model: {
                            value: _vm.form4.courseAssessment,
                            callback: function ($$v) {
                              _vm.$set(_vm.form4, "courseAssessment", $$v)
                            },
                            expression: "form4.courseAssessment",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "10px" } },
                          [
                            _c("FileUpload", {
                              attrs: {
                                title: "PDF附件一上传",
                                accept: _vm.acceptPdf,
                              },
                              on: { successData: _vm.getUploadQuestions1 },
                            }),
                            _vm._v(" "),
                            _vm.form4.testQuestions1.fileName
                              ? _c("div", { staticClass: "fjTit" }, [
                                  _vm._v(
                                    "\n              已上传：" +
                                      _vm._s(
                                        _vm.form4.testQuestions1.fileName
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "10px" } },
                          [
                            _c("FileUpload", {
                              attrs: {
                                title: "PDF附件二上传",
                                accept: _vm.acceptPdf,
                              },
                              on: { successData: _vm.getUploadQuestions2 },
                            }),
                            _vm._v(" "),
                            _vm.form4.testQuestions2.fileName
                              ? _c("div", { staticClass: "fjTit" }, [
                                  _vm._v(
                                    "\n              已上传：" +
                                      _vm._s(
                                        _vm.form4.testQuestions2.fileName
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit4("form4")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.curIndex == 5
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form5",
                attrs: {
                  model: _vm.form5,
                  "label-width": "170px",
                  rules: _vm.rules5,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程应用情况：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 18,
                            maxlength: "900",
                            "show-word-limit": "",
                            placeholder:
                              "请输入在申报高校教学中的应用情况；面向其他职业院校学生和社会学习者应用情况及效果，其中包括使用课程学校总数、选课总人数、使用课程学校名称等。(不超过800字)",
                          },
                          model: {
                            value: _vm.form5.courseApplication,
                            callback: function ($$v) {
                              _vm.$set(_vm.form5, "courseApplication", $$v)
                            },
                            expression: "form5.courseApplication",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit5("form5")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.curIndex == 6
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form6",
                attrs: {
                  model: _vm.form6,
                  "label-width": "170px",
                  rules: _vm.rules6,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "课程建设计划：" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 18,
                            maxlength: "600",
                            "show-word-limit": "",
                            placeholder:
                              "请输入今后五年继续面向学校和社会开放学习服务计划，包括面向学校的教学应用计划和面向社会开设期次、持续更新和提供教学服务设想等。(不超过500字)",
                          },
                          model: {
                            value: _vm.form6.curriculumConstructionPlan,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form6,
                                "curriculumConstructionPlan",
                                $$v
                              )
                            },
                            expression: "form6.curriculumConstructionPlan",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit6("form6")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.curIndex == 7
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "form7",
                attrs: {
                  model: _vm.form7,
                  "label-width": "170px",
                  rules: _vm.rules7,
                },
              },
              [
                _c("el-row", { staticClass: "marRight20" }, [
                  _c(
                    "div",
                    { staticClass: "majorWarp" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "政治审查意见 (必填)：",
                            "label-width": "170px",
                          },
                        },
                        [
                          _c("div", { staticClass: "fj" }, [
                            _vm._v(
                              "\n              本校党委对本校课程团队成员情况进行审查，以及对课程政治导向把关审查情况，确保课程正确的政治方向、价值取向。团队涉及多校时需要各校分别出具。须由学校党委盖章。无统一格式要求。\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("FileUpload", {
                            attrs: {
                              title: "PDF附件上传",
                              accept: _vm.acceptPdf,
                            },
                            on: { successData: _vm.getUploadPoliticsFile },
                          }),
                          _vm._v(" "),
                          _vm.form7.politicsFile.fileName
                            ? _c("div", { staticClass: "fjTit" }, [
                                _vm._v(
                                  "\n              已上传：" +
                                    _vm._s(_vm.form7.politicsFile.fileName) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "majorWarp" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "学术性评价意见 (必填)：",
                            "label-width": "170px",
                          },
                        },
                        [
                          _c("div", { staticClass: "fj" }, [
                            _vm._v(
                              "\n              学术评价意见由学校学术性组织（校教指委或学术委员会等），或相关部门组织的相应学科专业领域专家（不少于3名）组成的学术审查小组，经一定程序评价后出具。须由学术性组织盖章或学术审查小组全部专家签字。无统一格式要求。\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("FileUpload", {
                            attrs: {
                              title: "PDF附件上传",
                              accept: _vm.acceptPdf,
                            },
                            on: { successData: _vm.getUploadLearningFile },
                          }),
                          _vm._v(" "),
                          _vm.form7.learningFile.fileName
                            ? _c("div", { staticClass: "fjTit" }, [
                                _vm._v(
                                  "\n              已上传：" +
                                    _vm._s(_vm.form7.learningFile.fileName) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "majorWarp" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "课程数据信息表 (必填)：",
                            "label-width": "170px",
                          },
                        },
                        [
                          _c("div", { staticClass: "fj" }, [
                            _vm._v("须课程平台单位盖章"),
                          ]),
                          _vm._v(" "),
                          _c("FileUpload", {
                            attrs: {
                              title: "PDF附件上传",
                              accept: _vm.acceptPdf,
                            },
                            on: { successData: _vm.getUploadCourseDataFile },
                          }),
                          _vm._v(" "),
                          _vm.form7.courseDataFile.fileName
                            ? _c("div", { staticClass: "fjTit" }, [
                                _vm._v(
                                  "\n              已上传：" +
                                    _vm._s(_vm.form7.courseDataFile.fileName) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "majorWarp" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "校外评价意见 (选填)：",
                            "label-width": "170px",
                          },
                        },
                        [
                          _c("div", { staticClass: "fj" }, [
                            _vm._v(
                              "\n              此评价意见作为课程有关学术水平、课程质量、应用效果等某一方面的佐证性材料或补充材料，可由教育部及省教指委等专家组织，有关学术组织、课程联盟组织、课程平台、课程应用院校（或院校相应院系）等出具，也可由相应学科专业领域的校外专家学者出具。须相关单位盖章或专家签字。评价意见以1份为宜，不得超过２份。无统一格式要求。\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("FileUpload", {
                            attrs: {
                              title: "PDF附件上传",
                              accept: _vm.acceptPdf,
                            },
                            on: { successData: _vm.getUploadOutsideSchoolFile },
                          }),
                          _vm._v(" "),
                          _vm.form7.outsideSchoolFile.fileName
                            ? _c("div", { staticClass: "fjTit" }, [
                                _vm._v(
                                  "\n              已上传：" +
                                    _vm._s(_vm.form7.outsideSchoolFile.fileName)
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "delFile",
                                    on: { click: _vm.delSchoolFile1 },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form7.outsideSchoolFile1.fileName
                            ? _c("div", { staticClass: "fjTit" }, [
                                _vm._v(
                                  "\n              已上传：" +
                                    _vm._s(
                                      _vm.form7.outsideSchoolFile1.fileName
                                    )
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "delFile",
                                    on: { click: _vm.delSchoolFile2 },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "majorWarp" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "其它材料：",
                            "label-width": "170px",
                          },
                        },
                        [
                          _c("div", { staticClass: "fj" }, [
                            _vm._v("（限2份，可选提供）"),
                          ]),
                          _vm._v(" "),
                          _c("FileUpload", {
                            attrs: {
                              title: "PDF附件上传",
                              accept: _vm.acceptPdf,
                            },
                            on: { successData: _vm.getUploadOther },
                          }),
                          _vm._v(" "),
                          _vm.form7.otherFile.fileName
                            ? _c("div", { staticClass: "fjTit" }, [
                                _vm._v(
                                  "\n              已上传：" +
                                    _vm._s(_vm.form7.otherFile.fileName)
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "delFile",
                                    on: { click: _vm.delFile1 },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form7.otherFile1.fileName
                            ? _c("div", { staticClass: "fjTit" }, [
                                _vm._v(
                                  "\n              已上传：" +
                                    _vm._s(_vm.form7.otherFile1.fileName)
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "delFile",
                                    on: { click: _vm.delFile2 },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit7("form7")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }